'use client';

import { useLatestEntries } from '@/lib/fetch/useLatestEntries';
import Box from '@/polymorphics/Box';
import Btn from '@/polymorphics/Btn';
import Container from '@/polymorphics/Container';
import Flex from '@/polymorphics/Flex';
import CardGrid from '../CardGrid';
import ArticleCard from '../EntryCard/EntryCard.Article';
import SkeletonCards from '../Skeleton/SkeletonCards';

export default function ArticleIndex() {
  const {
    result = [],
    loading,
    fetchMore,
    trigger,
  } = useLatestEntries(
    { section: 'article', orderBy: 'postDate desc', offset: 0, limit: 12 },
    'article_Entry'
  ) ?? {};

  // TODO: Rewrite button state to listen to how many items are left to fetch

  return (
    <Container>
      <Box cx={{ pY: '7' }}>
        {loading ? (
          <SkeletonCards
            amount={12}
            md={6}
            rowGutter={false}
            cx={{ rowGap: '7' }}
            SkeletonItems={{
              cx: { flexDirection: 'column', rowGap: '2' },
              items: [
                { variant: 'rounded', height: 250, width: '100%', sx: { bgcolor: 'lightgrey' } },
                { variant: 'rounded', height: 50, width: '75%', sx: { bgcolor: 'lightgrey' } },
                { variant: 'rounded', height: 20, width: '60%', sx: { bgcolor: 'lightgrey' } },
              ],
            }}
          />
        ) : (
          <CardGrid
            rowGutter={false}
            Component={ArticleCard}
            items={result}
            md={6}
            cx={{ rowGap: '7' }}
          />
        )}
        {trigger && (
          <Flex justify="center" cx={{ width: 'full', pT: '7' }}>
            <Btn
              variant="pill"
              colored
              size="lg"
              cx={{ cursor: 'pointer' }}
              onClick={fetchMore}
              focus>
              View more
            </Btn>
          </Flex>
        )}
      </Box>
    </Container>
  );
}
